import { useAppDispatch, useTypedSelector } from "@/config/configureAppStore";
import { useAuth } from "@/lib/firebase/firebaseHooks";
import { setCalendlyDialog } from "@/reducers/slices/dialogSlice/dialogSlice";
import { themeVariables } from "@/themes/themeVariables";
import { Box, styled, useTheme } from "@mui/material";
import { useMemo } from "react";
import { PopupModal } from "react-calendly";

const COUNTRY_CODE_SET_1 = [
  "US",
  "CA",
  "MX",
  "NZ",
  "AU",
  "AR",
  "BR",
  "CO",
  "PE"
];

export const StyledCalendlyWrapper = styled(Box)(({ theme }) => ({
  ".calendly-popup, .calendly-overlay iframe": {
    colorScheme: "white"
  },
  ".calendly-overlay": {
    backgroundColor: themeVariables[theme.palette.mode].backdropBackground
  }
}));

export const CALENDLY_WRAPPER_ID = "murf-calendly-wrapper";

const Calendly = () => {
  const user = useAuth();
  const userEnrichDetails = useTypedSelector((state) => state.user);
  const organizationDetails = useTypedSelector(
    (state) => state.globalState.organizationDetails
  );
  const dispatch = useAppDispatch();
  const open = useTypedSelector((state) => state.dialog.calendlyDialog.open);
  const props = useTypedSelector((state) => state.dialog.calendlyDialog.props);

  const { useCase, utmCampaign } = props || {};

  const handleClose = () => {
    dispatch(setCalendlyDialog(false));
  };

  const theme = useTheme();

  const pageSettings = {
    backgroundColor: theme.palette.background.paper,
    hideEventTypeDetails: 0,
    hideLandingPageDetails: 1,
    hideGdprBanner: 1,
    primaryColor: theme.palette.primary.main,
    textColor: theme.palette.text.primary,
    textAlign: "center"
  };
  const prefill = {
    email: user?.email,
    name: `${user?.displayName}`,
    customAnswers: {
      a2: userEnrichDetails?.countryCode,
      a3: useCase,
      a5: organizationDetails?.employeeSize
        ? String(organizationDetails.employeeSize)
        : undefined
    }
  };

  const calendlyUrl = useMemo(() => {
    if (
      userEnrichDetails?.countryCode &&
      COUNTRY_CODE_SET_1.includes(userEnrichDetails.countryCode)
    ) {
      return "https://calendly.com/murf-ai/exploration-call-for-murf-dub-studio";
    }
    return "https://calendly.com/murf-ai/exploration-call-with-murf-ai-dub";
  }, [userEnrichDetails?.countryCode]);

  return (
    <PopupModal
      url={calendlyUrl}
      rootElement={
        document.getElementById(CALENDLY_WRAPPER_ID) ||
        document.getElementById("root") ||
        document.body
      }
      pageSettings={pageSettings as any}
      iframeTitle="Exploration Call for Murf Dub"
      prefill={prefill}
      utm={{
        utmSource: "contact_sales",
        utmMedium: "dub_platform",
        utmCampaign: utmCampaign
      }}
      open={open}
      onModalClose={handleClose}
    />
  );
};

export default Calendly;
